import { render, staticRenderFns } from "./QueueDetails.vue?vue&type=template&id=bf72b856&scoped=true&"
import script from "./QueueDetails.vue?vue&type=script&lang=js&"
export * from "./QueueDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf72b856",
  null
  
)

export default component.exports